import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import SectionHeading from 'Components/Insights/components/SectionHeading/SectionHeading';
import { gbpCurrencyFormatter } from 'Utilities/formatters';
import type { UseInsightsRecentSoldResult } from 'Utilities/hooks/recentSoldPrices/useRecentSoldPrices';

import { PLACEHOLDER } from '../RecentSoldPrices/RecentSoldPrices.consts';
import { numberFieldHasValue } from '../RecentSoldPrices/RecentSoldPrices.helpers';

import { InsightCard } from './components/InsightCard/InsightCard';
import LocalTexts from './OverThePastYear.texts';

import styles from './OverThePastYear.module.scss';

const LocalT = new MDText(LocalTexts);

type OverThePastYearProps = {
	insightsRecentSold: UseInsightsRecentSoldResult;
};

export const OverThePastYear: React.FC<OverThePastYearProps> = ({ insightsRecentSold }) => {
	const { data } = insightsRecentSold;

	if (!data) {
		return null;
	}

	return (
		<section className={styles.container}>
			<SectionHeading text={LocalT.translate('header.overThePastYear')} />
			<div className={styles.insightCardsContainer}>
				<InsightCard
					cypressId={`${cypressIds.insights.recentSoldPricesStatCard}-0`}
					title={LocalT.translate('cards.averageSoldPrice')}
					value={
						numberFieldHasValue(data.averageSoldPriceInLastYear)
							? gbpCurrencyFormatter({ maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(
									data.averageSoldPriceInLastYear,
							  )
							: PLACEHOLDER
					}
				/>
				<InsightCard
					cypressId={`${cypressIds.insights.recentSoldPricesStatCard}-1`}
					title={LocalT.translate('cards.highestSoldPrice')}
					value={
						numberFieldHasValue(data.highestSoldPriceInLastYear)
							? gbpCurrencyFormatter({ maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(
									data.highestSoldPriceInLastYear,
							  )
							: PLACEHOLDER
					}
				/>
				<InsightCard
					cypressId={`${cypressIds.insights.recentSoldPricesStatCard}-2`}
					title={LocalT.translate('cards.lowestSoldPrice')}
					value={
						numberFieldHasValue(data.lowestSoldPriceInLastYear)
							? gbpCurrencyFormatter({ maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(
									data.lowestSoldPriceInLastYear,
							  )
							: PLACEHOLDER
					}
				/>
			</div>
		</section>
	);
};
